import * as React from "react";
import { forwardRef } from "react";
const MagnifierSVG = (props, ref) => React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", ref: ref, ...props },
    React.createElement("path", { fillRule: "evenodd", d: "M3 11a8 8 0 1 1 16 0 8 8 0 0 1-16 0m8-6a6 6 0 1 0 0 12 6 6 0 0 0 0-12", clipRule: "evenodd" }),
    React.createElement("path", { fillRule: "evenodd", d: "M15.293 15.293a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1-1.414 1.414l-5-5a1 1 0 0 1 0-1.414", clipRule: "evenodd" }));
const ForwardRef = forwardRef(MagnifierSVG);
export default ForwardRef;
//# sourceMappingURL=Magnifier.js.map